import { Box, ListItem } from "@mui/material"
import { styled } from "@mui/material/styles"

export const StyledBox = styled(Box)(({ theme }) => ({
  display: "flex",
  [theme.breakpoints.down("lg")]: {
    flexWrap: "wrap",
    alignItems: "center"
  }
}))

export const StyledListItem = styled(ListItem)(({ theme }) => ({
  padding: 0
}))

export const StyledSubListItem = styled(ListItem)(({ theme }) => ({
  padding: 0,
  paddingLeft: theme.spacing(4),
  paddingTop: theme.spacing(1)
}))
